import { Request } from "./HttpService";

export const emailService = {
  exist(email) {
    return Request(`vitae/email/${email}`, "GET");
  },
  changeEmail(email, interviewId) {
    return Request(`vitae/email`, "PUT", {
      email: email,
      interviewId: interviewId
    });
  }
};
